// NOTE(rtlong): this is here to mock it out in specs (it is annoyingly difficult to mock out window.location)

const navigateHard = (uri, { replace = false } = {}) => {
  console.log("Navigating to", uri);
  window.location[replace ? "replace" : "assign"](uri);
};

export default navigateHard;
